import React from "react";

const AboutContent = {
  subHeading: "About Us",
  heading:
    "As an AI-powered agency, we leverage cutting-edge technology to strategize, design, and develop intelligent user experiences, optimizing engagement across all digital platforms and brand touchpoints.",
};

const About: React.FC = () => {
  const { subHeading, heading } = AboutContent;
  return (
    <div
      className="py-[2em] sm:py-[3.25em] md:py-[4em] xl:py-[6.25em] story relative border-t border-solid border-[#181823]"
      id="about"
    >
      <div className="w-full mx-auto max-w-[94.25em] px-[1.5em] md:px-[2.5em]">
        <div className="w-full">
          <h5
            className="text-white text-[1.1em] xl:text-[1.5em] leading-[1.34em]
            mb-[1em] font-medium tracking-[0.05em]"
          >
            {subHeading}
          </h5>
          <h2 className="text-white text-2xl md:text-[38px] leading-[1.25em] font-light mb-0 lg:max-w-[88%]">
            {heading}
          </h2>
        </div>
      </div>

      <div className="absolute top-0 right-0 w-[725px] h-[725px] bg-[#1E1B45] blur-[15.625em] rounded-[6.25em] opacity-70 translate-x-[70%] translate-y-[0%] pointer-events-none" />
    </div>
  );
};

export default About;
